import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    SET_NAVIGATION_VARIANT: createAction('GLOBAL/NAVIGATION/SET_NAVIGATION_VARIANT'),
};
export const initialState = Map({
    navigationVariant: 'DEFAULT',
});
const reducer = handleActions({
    [actions.SET_NAVIGATION_VARIANT]: (state, action) => {
        return state.set('navigationVariant', action.payload);
    },
}, initialState);
export default reducer;
